// extracted by mini-css-extract-plugin
export default {"logosContainer":"footerLogos_logosContainer__QNwTF","logosWrapper":"footerLogos_logosWrapper__t0jLw","wrapper":"footerLogos_wrapper__AIS7+","logoItem":"footerLogos_logoItem__MNE0g"};